// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAuditLogsLinkMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateAuditLogsLinkMutation = { __typename?: 'Mutation', auditLogsLink?: any | null };

export const Operations = {
  Mutation: {
    CreateAuditLogsLink: 'CreateAuditLogsLink' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateAuditLogsLinkDocument = gql`
    mutation CreateAuditLogsLink {
  auditLogsLink
}
    `;
export type CreateAuditLogsLinkMutationFn = Apollo.MutationFunction<CreateAuditLogsLinkMutation, CreateAuditLogsLinkMutationVariables>;

/**
 * __useCreateAuditLogsLinkMutation__
 *
 * To run a mutation, you first call `useCreateAuditLogsLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditLogsLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditLogsLinkMutation, { data, loading, error }] = useCreateAuditLogsLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateAuditLogsLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuditLogsLinkMutation, CreateAuditLogsLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuditLogsLinkMutation, CreateAuditLogsLinkMutationVariables>(CreateAuditLogsLinkDocument, options);
      }
export type CreateAuditLogsLinkMutationHookResult = ReturnType<typeof useCreateAuditLogsLinkMutation>;
export type CreateAuditLogsLinkMutationResult = Apollo.MutationResult<CreateAuditLogsLinkMutation>;
export type CreateAuditLogsLinkMutationOptions = Apollo.BaseMutationOptions<CreateAuditLogsLinkMutation, CreateAuditLogsLinkMutationVariables>;